<p>oauth2 success</p>
<div *ngIf="successMessage">
    {{successMessage}}
</div>
